export const MainColor = '#FF0000';
export const BackgroundLightColor = '#FFFFFF';
export const BackgroundDarkColor = '#F2F9F8';
export const BackgroundLightColorTransparent5 = 'rgba(5, 41, 39, 0.05)';
export const TextDarkColor = '#052927';
export const TextLightColor = '#4A6563';
export const TextLinkColor = '#00857E';
export const TextLinkColorTransparent20 = 'rgba(0, 133, 126, 0.2)';
export const TextLinkColorTransparent50 = 'rgba(0, 133, 126, 0.5)';
export const TextLinkColorTransparent80 = 'rgba(0, 133, 126, 0.8)';
export const IconsAndButtonsColor = '#00857E';
export const IconsAndButtonsWithoutGradient = '#00857E';
export const LightTopicColor = '#04B2A8';
export const SelectedOptionBackground = '#F8FCFB';
export const SelectedOptionBorder = '#00857E';
export const TextPlaceholderColor = '#646464';
export const DangerColor = '#FF0000';
export const DestructiveColor = '#D60000';

// TODO this is the new primary color of the app. we must transition to using this instead of MainColor
export const PrimaryColor = '#00857E';
export const PrimaryBackgroundGrey = '#F7F7F7';

export const GreyColor = '#646464';
export const LightGreyColor = '#E6E6E6';
export const LightGreyColorF9 = '#F9F9F9';
export const LightGreyColorF8 = '#F8F8F8';
export const LightGreyColorF5 = '#F5F5F5';
export const LightGreyColorF4 = '#F4F4F4';
export const LightGreyColorF3 = '#F3F3F3';
export const WellnessChartCartesianGridColor = '#D7D8DB';

// TODO These need to be replaced with the colors defined by UI designer
export const SuccessColor = '#40a348';
export const AlertColor = '#F8924A';
export const ErrorColor = '#B71313';

export const ErrorBackgroundColor = '#FF00001A';
export const NewTableRowBorderColor = '#FF000033';
export const OldTableRowBorderColor = '#66898733';
export const HistoricalRowBorderColor = '#FFCCCC';

export const DisabledColor = '#668987';

export const OrangeTextColor = '#F2994A';
export const GreenTextColor = '#219653';
export const RedTextColor = '#EB5757';
export const RedBannerColor = '#FFE6E6';

export const GrayBackgroundColor = '#333333';

export const OrangeLineColor = '#F2994A';
export const YellowLineColor = '#F2C94C';
export const GreenLineColor = '#27AE60';
export const GreenLightLineColor = '#85D372';
export const GrayLineColor = '#DCDCDC';
export const GreenOutlineColor = '#00A198';

export const GradientColorMax = '#F2F9F8';
export const GradientColorMin = '#D9F3F2';

export const BulletFillGreen = '#93d6af';
export const BulletFillLightGreen = '#B2EBA5';
export const BulletFillOrange = '#f7cca4';
export const BulletFillYellow = '#f1e1a2';
export const BulletFillRed = '#ff7f7f';

export const ChatboxMessageColor = '#08B6AB40';
export const PopupShadow = '#017D7D1A';
export const ReplyColor = '#0529270f';
export const FocusedReplyColor = '#f2994a1f';
export const BorderColor = '#668987';
export const ScrollbarColor = '#76a3a0';
export const ScrollbarFocusedColor = '#668987';

export const InputFieldBackgroundColor = '#E7F8F7';

export const LightTagColor = '#CDF0EE';
export const LightTeal = '#0ECDC1';

export const White = '#FFFFFF';
export const Black = '#000000';

export const CountColor = '#08B6AB';
export const HighlightedBackgroundColor = 'rgba(255, 0, 0, 0.15)';
export const LightMainColor = '#FDEAEA';

export const CarecirclePointsAchieved = '#B2C4C3';
export const IsabelItemBackground = '#4F96D1';
export const LightGreenColor = '#E6F3F2';
export const DarkGreenColor = '#5A9F9C';
export const WellnessTrackerChartArea = '#FBDFB6';

export const HeaderShadow = '#017D7D';
export const BackgroundGrey = '#F9F9F9';
export const JourneyAvatarBackgroundColor = '#EC8E73';

export const DestructiveRed = '#D60000';
export const DropdownBorderColor = '#B1B1B1';
export const DropdownBackgroundColor = '#F3F3F3';
export const ChatRoomNameColor = '#FEDDB7';

export const WarningYellowColor = '#FDF9F3';
export const UploadingVideoPaleGreenColor = '#F4FCFB';
export const DarkTextColor = '#2C2C2C';
export const BackgroundLightGreenColor = '#F4FCFB';
export const UnsentMessagePinkColor = '#FDEDED';

export const BackgroundLightColorTransparent6 = '#ddf1f0';

export const DarkBlueColor = '#1B4E61';
export const DarkRedColor = '#E84949';
export const DarkYellowColor = '#CF800A';
